import { defineNuxtPlugin } from "#imports";
import { reactive } from "vue";
const plugin = defineNuxtPlugin(() => {
  return {
    provide: reactive({
      ssrClientHints: {
        firstRequest: false,
        prefersColorSchemeAvailable: false,
        prefersReducedMotionAvailable: false,
        viewportHeightAvailable: false,
        viewportWidthAvailable: false
      }
    })
  };
});
export default plugin;
